import {
  FETCH_COLOCATION_NETWORK_UPLINK,
  FETCH_COLOCATION_NETWORK_UPLINK_IS_ERROR,
  FETCH_COLOCATION_NETWORK_UPLINK_IS_PENDING,
  FETCH_PDU,
  FETCH_PDU_IS_ERROR,
  FETCH_PDU_IS_PENDING,
  RESET_REDUCER,
} from 'services/Telemetry/Colocation/types';

const INITIAL_STATE = {
  fetchColocationNetworkUplinkIsCompleted: false,
  fetchColocationNetworkUplinkIsPending: false,
  fetchColocationNetworkUplinkIsError: null,
  upLinks: {},
  pduA: [],
  pduB: [],
  fetchPDUIsCompleted: false,
  fetchPDUIsPending: false,
  fetchPDUIsError: null,
};

const telemetryColocationReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_COLOCATION_NETWORK_UPLINK:
      return {
        ...state,
        upLinks: {
          ...state.upLinks,

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          [action.uplinkId]: action.data[0],
        },
        fetchColocationNetworkUplinkIsCompleted: true,
        fetchColocationNetworkUplinkIsPending: false,
        fetchColocationNetworkUplinkIsError: null,
      };
    case FETCH_COLOCATION_NETWORK_UPLINK_IS_PENDING:
      return {
        ...state,
        fetchColocationNetworkUplinkIsCompleted: false,
        fetchColocationNetworkUplinkIsPending: true,
        fetchColocationNetworkUplinkIsError: null,
      };
    case FETCH_COLOCATION_NETWORK_UPLINK_IS_ERROR:
      return {
        ...state,
        fetchColocationNetworkUplinkIsCompleted: true,
        fetchColocationNetworkUplinkIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchColocationNetworkUplinkIsError: action.error,
      };
    case FETCH_PDU:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        [`pdu${action.feedType}`]: action.data,
        fetchPDUIsCompleted: true,
        fetchPDUIsPending: false,
        fetchPDUIsError: null,
      };
    case FETCH_PDU_IS_PENDING:
      return {
        ...state,
        fetchPDUIsCompleted: false,
        fetchPDUIsPending: true,
        fetchPDUIsError: null,
      };
    case FETCH_PDU_IS_ERROR:
      return {
        ...state,
        fetchPDUIsCompleted: true,
        fetchPDUIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchPDUIsError: action.error,
      };
    case RESET_REDUCER:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default telemetryColocationReducer;
